// src/utils/ranking.js
// How a ranking value is shown. The backend says what the number is (`ranking`: unit, decimals, ...);
// without it the original score is assumed.
export const CLASSIC_RANKING = { method: 'classic', name: 'Classic score', unit: 'Score', decimals: 2 };

export const formatScore = (value, ranking = CLASSIC_RANKING) => Number(value).toFixed(ranking.decimals ?? 2);
